import React from 'react';
import DeleteAccountPage from './modules/DeleteAccount/DeleteAccountPage';
import './App.css';


function App() {
  console.log('NODE_ENV====================================');
  console.log(process.env.NODE_ENV);
  console.log('====================================');
  console.log('REACT_APP_ENV====================================');
  console.log(process.env.REACT_APP_ENV);
  console.log('====================================');
  console.log('REACT_ENV====================================');
  console.log(process.env.REACT_ENV);
  console.log('====================================');
  return (
    <div className="app-container">
      <DeleteAccountPage />
    </div>
  );
}

export default App;
